import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AppRoute from '../route';
import CustomModal from '../components/modal/Modal';
import { StackModal } from '../components/modal/StackModal';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { showModal, hideModal, pushModalToStack, popModalFromStack } from '../actions/commonActions';
import { Spin } from 'antd';
import './Main.scss';

class Main extends Component {
  render() {
    const { common: { isLoading= false }, modal, modalStack } = this.props;
    const antIcon = <Loading3QuartersOutlined className="spinnerIcon" spin />;
    return (
      <BrowserRouter basename="/">
        <Spin indicator={antIcon} className="spinner" tip="Loading..." spinning={isLoading} >
          <CustomModal {...modal} {...this.props}/>
          <StackModal modalStack={modalStack} {...this.props} />
          <AppRoute />
        </Spin>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = state => ({
  common: state.common,
  modal: state.modal,
  modalStack: state.stackModal.modalStack
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  showModal,
  hideModal,
  pushModalToStack,
  popModalFromStack
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Main);